import { Action, createReducer, on } from '@ngrx/store';
import { State, initialState } from '../auth.state';

import * as actions from './login.actions';
import { SessionReadyAction } from '../../actions';

export const authLoginReducer = createReducer(
  initialState,
  on(actions.RequestLoginAction, (state) => ({ ...state, loading: true, resetPassword: false })),
  on(actions.ResponseSuccessAuthLoginAction, SessionReadyAction, (state, { session, userId }) => {
    return {
      ...state,
      auth: {
        session,
        userId: userId,
      },
    };
  }),
  on(actions.ResponseFailAuthLoginAction, (state, { payload }) => ({
    ...state,
    auth: null,
    loading: false,
    error: payload,
  })),
  on(actions.CreateLoginFlow, actions.GetLoginFlow, (state) => ({
    ...state,
    loading: true,
  })),
  on(actions.SuccessLoginFlow, (state, { flow }) => ({
    ...state,
    loginFlow: flow,
    loading: false,
  })),
  on(actions.RequestUpdateLoginFlow, (state) => ({
    ...state,
    loading: true,
  })),
  on(actions.SuccessUpdateLoginFlow, (state, { result }) => ({
    ...state,
    loading: false,
    auth: {
      session: result.session,
      userId: result.session.identity?.metadata_public['ca_member_id'],
    },
  })),
  on(actions.FailUpdateLoginFlow, (state, { error, flow }) => ({
    ...state,
    loading: false,
    error: error,
    loginFlow: flow,
  })),
  on(actions.RequireLogin, (state, { postLoginRoute }) => ({ ...state, postLoginRoute }))
);
